import { Icon } from "Components"
import { InfoTooltip } from "Pages/Dashboard/components"

const Label = ({ tooltipText = "", labelText }: { tooltipText?: string, labelText: string }) => {
    return tooltipText ? <div>
        {labelText}
        <InfoTooltip title={tooltipText}>
            <Icon type={"infoTooltip"} />
        </InfoTooltip>
    </div> : <span>{labelText}</span>
}

export default Label;